import React from "react"

// --- FULL BANNER CONFIGURATION (Percentage-based for 100% responsive coverage) ---
const FULL_VERTICAL_LINES = [
    { className: "v-18", style: { left: "95.3%", height: "100%", top: "0%", opacity: 0.45 } },
    { className: "v-17", style: { left: "85.9%", height: "80.8%", top: "19.2%", opacity: 0.45 } },
    { className: "v-16", style: { left: "74.2%", height: "64.9%", top: "0%", opacity: 0.42 } },
    { className: "v-15", style: { left: "65.6%", height: "84.1%", top: "12%", opacity: 0.48 } },
    { className: "v-14", style: { left: "53.1%", height: "100%", top: "0%", opacity: 0.45 } },
    { className: "v-13", style: { left: "40.6%", height: "74.5%", top: "7.2%", opacity: 0.48 } },
    { className: "v-12", style: { left: "29.7%", height: "100%", top: "0%", opacity: 0.42 } },
    { className: "v-11", style: { left: "18.0%", height: "76%", top: "24%", opacity: 0.45 } },
    { className: "v-10", style: { left: "7.4%", height: "67.3%", top: "0%", opacity: 0.42 } }
]

const FULL_HORIZONTAL_LINES = [
    { className: "h-9", style: { top: "96.2%", left: "23.4%", width: "76.6%", opacity: 0.45 } },
    { className: "h-8", style: { top: "81.7%", left: "79.7%", width: "20.3%", opacity: 0.42 } },
    { className: "h-7", style: { top: "81.7%", left: "0%", width: "100%", opacity: 0.48 } },
    { className: "h-6", style: { top: "63.7%", left: "14.1%", width: "85.9%", opacity: 0.45 } },
    { className: "h-5", style: { top: "48.1%", left: "41.4%", width: "58.6%", opacity: 0.50 } },
    { className: "h-4", style: { top: "48.1%", left: "0%", width: "41.4%", opacity: 0.45 } },
    { className: "h-3", style: { top: "27.6%", left: "74.2%", width: "25.8%", opacity: 0.45 } },
    { className: "h-2", style: { top: "27.6%", left: "7.0%", width: "93.0%", opacity: 0.52 } },
    { className: "h-1", style: { top: "10.8%", left: "53.1%", width: "46.9%", opacity: 0.42 } },
    { className: "h-0", style: { top: "10.8%", left: "0%", width: "53.1%", opacity: 0.48 } }
]

const FULL_JUNCTIONS = [
    { x: "95.2%", y: "81.2%" }, { x: "95.2%", y: "47.6%" }, { x: "95.2%", y: "27.2%" }, { x: "95.2%", y: "10.3%" },
    { x: "85.8%", y: "81.2%" }, { x: "85.8%", y: "47.6%" }, { x: "85.8%", y: "27.2%" },
    { x: "74.1%", y: "47.6%" }, { x: "74.1%", y: "27.2%" }, { x: "74.1%", y: "10.3%" },
    { x: "65.5%", y: "95.7%" }, { x: "65.5%", y: "81.2%" }, { x: "65.5%", y: "47.6%" }, { x: "65.5%", y: "27.2%" },
    { x: "53.0%", y: "95.7%" }, { x: "53.0%", y: "81.2%" }, { x: "53.0%", y: "63.2%" }, { x: "53.0%", y: "47.6%" }, { x: "53.0%", y: "27.2%" }, { x: "53.0%", y: "10.3%" },
    { x: "40.5%", y: "81.2%" }, { x: "40.5%", y: "63.2%" }, { x: "40.5%", y: "27.2%" }, { x: "40.5%", y: "10.3%" },
    { x: "29.5%", y: "95.7%" }, { x: "29.5%", y: "81.2%" }, { x: "29.5%", y: "63.2%" }, { x: "29.5%", y: "47.6%" }, { x: "29.5%", y: "27.2%" }, { x: "29.5%", y: "10.3%" },
    { x: "17.8%", y: "81.2%" }, { x: "17.8%", y: "63.2%" }, { x: "17.8%", y: "47.6%" }, { x: "17.8%", y: "27.2%" },
    { x: "7.3%", y: "47.6%" }, { x: "7.3%", y: "27.2%" }, { x: "7.3%", y: "10.3%" }
]

const FULL_TRAVELERS = [
    { x: "53.0%", y: "99%", d: '0s', cls: 't-0' },
    { x: "29.5%", y: "0%", d: '-1.2s', cls: 't-1' },
    { x: "85.8%", y: "99%", d: '-2.4s', cls: 't-2' },
    { x: "65.5%", y: "11%", d: '-3.6s', cls: 't-3' },
    { x: "40.5%", y: "81%", d: '-4.8s', cls: 't-4' },
    { x: "7.3%", y: "0%", d: '-6s', cls: 't-5' },
    { x: "23.2%", y: "95%", d: '-7.2s', cls: 't-6' },
    { x: "70.1%", y: "81%", d: '-8.4s', cls: 't-7' },
    { x: "41.2%", y: "47%", d: '-9.6s', cls: 't-8' },
    { x: "99.8%", y: "27%", d: '-10.8s', cls: 't-9' },
    { x: "0%", y: "10%", d: '-12s', cls: 't-10' }
]

// --- PANEL CONFIGURATION ---
const PANEL_VERTICAL_LINES = [
    { className: "pv-0", style: { left: 29.69, height: 528, top: 0, opacity: 0.14 } },
    { className: "pv-1", style: { left: 71.88, height: 401, top: 126.92, opacity: 0.15 } },
    { className: "pv-2", style: { left: 118.75, height: 528, top: 0, opacity: 0.13 } },
    { className: "pv-3", style: { left: 162.5, height: 393.5, top: 38.08, opacity: 0.16 } },
    { className: "pv-4", style: { left: 212.5, height: 528, top: 0, opacity: 0.14 } },
    { className: "pv-5", style: { left: 262.5, height: 444, top: 63.46, opacity: 0.15 } },
    { className: "pv-6", style: { left: 296.88, height: 343, top: 0, opacity: 0.13 } },
    { className: "pv-7", style: { left: 343.75, height: 426.5, top: 101.54, opacity: 0.14 } },
    { className: "pv-8", style: { left: 381.25, height: 528, top: 0, opacity: 0.12 } }
]

const PANEL_HORIZONTAL_LINES = [
    { className: "ph-0", style: { top: 57.12, left: 0, width: 162.5, opacity: 0.16 } },
    { className: "ph-1", style: { top: 57.12, left: 212.5, width: 187.5, opacity: 0.14 } },
    { className: "ph-2", style: { top: 145.96, left: 28.13, width: 234.375, opacity: 0.18 } },
    { className: "ph-3", style: { top: 145.96, left: 296.88, width: 103.125, opacity: 0.15 } },
    { className: "ph-4", style: { top: 253.85, left: 0, width: 125, opacity: 0.15 } },
    { className: "ph-5", style: { top: 253.85, left: 165.63, width: 234.375, opacity: 0.17 } },
    { className: "ph-6", style: { top: 336.35, left: 56.25, width: 187.5, opacity: 0.14 } },
    { className: "ph-7", style: { top: 431.54, left: 0, width: 281.25, opacity: 0.16 } },
    { className: "ph-8", style: { top: 431.54, left: 318.75, width: 81.25, opacity: 0.13 } },
    { className: "ph-9", style: { top: 507.69, left: 93.75, width: 212.5, opacity: 0.15 } }
]

const PANEL_JUNCTION_X = [28.19, 70.38, 117.25, 161.00, 211.00, 261.00, 295.38, 342.25, 379.75]
const PANEL_JUNCTION_Y = [55.62, 144.46, 252.35, 334.85, 430.04, 506.19]

const PANEL_JUNCTIONS: { x: number; y: number }[] = []
PANEL_JUNCTION_X.forEach(x => {
    PANEL_JUNCTION_Y.forEach(y => {
        PANEL_JUNCTIONS.push({ x, y })
    })
})

const PANEL_TRAVELERS = [
    { x: 212.5, y: 523.5, d: '0s', cls: 'pt-0' },
    { x: 118.75, y: 0, d: '-1.5s', cls: 'pt-1' },
    { x: 343.75, y: 523.5, d: '-3.0s', cls: 'pt-2' },
    { x: 262.5, y: 58.9, d: '-4.5s', cls: 'pt-3' },
    { x: 162.5, y: 427.0, d: '-6.0s', cls: 'pt-4' },
    { x: 29.69, y: 0, d: '-7.5s', cls: 'pt-5' },
    { x: 71.88, y: 503.2, d: '-9.0s', cls: 'pt-6' },
    { x: 296.88, y: 427.0, d: '-10.5s', cls: 'pt-7' },
    { x: 162.5, y: 249.3, d: '-12.0s', cls: 'pt-8' },
    { x: 381.25, y: 141.4, d: '-13.5s', cls: 'pt-9' }
]

interface NewTransitLinesProps {
    className?: string;
    style?: React.CSSProperties;
    variant?: "full" | "panel";
}

export function NewTransitLines({ className = "", style = {}, variant = "full" }: NewTransitLinesProps) {
    const isFull = variant === "full"
    const verticalLines = isFull ? FULL_VERTICAL_LINES : PANEL_VERTICAL_LINES
    const horizontalLines = isFull ? FULL_HORIZONTAL_LINES : PANEL_HORIZONTAL_LINES
    const junctions = isFull ? FULL_JUNCTIONS : PANEL_JUNCTIONS
    const travelers = isFull ? FULL_TRAVELERS : PANEL_TRAVELERS

    return (
        <div className={`asc-transit-map ${isFull ? 'asc-full' : 'asc-panel'} ${className}`.trim()} style={style}>
            <style>{`
                .asc-transit-map {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    pointer-events: none;
                    user-select: none;
                }
                .asc-transit-map.asc-full {
                    position: absolute !important;
                    top: 0 !important;
                    bottom: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    width: 100% !important;
                    height: 100% !important;
                    max-width: none !important;
                    margin: 0 !important;
                    transform: none !important;
                    mask-image: linear-gradient(to right, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.18) 35%, rgba(0, 0, 0, 0.45) 65%, rgba(0, 0, 0, 0.72) 100%);
                    -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.18) 35%, rgba(0, 0, 0, 0.45) 65%, rgba(0, 0, 0, 0.72) 100%);
                }
                .asc-transit-map.asc-panel {
                    position: absolute !important;
                    top: 0 !important;
                    left: 0 !important;
                    width: 400px !important;
                    height: 528px !important;
                    max-width: none !important;
                    transform: none !important;
                    overflow: hidden !important;
                    pointer-events: none !important;
                }

                .asc-transit-line-v {
                    position: absolute;
                    width: 1px;
                    background: linear-gradient(180deg, rgba(136, 0, 21, 0.55) 0%, rgba(136, 0, 21, 0.25) 100%);
                }
                .asc-transit-line-h {
                    position: absolute;
                    height: 1px;
                    background: linear-gradient(90deg, rgba(136, 0, 21, 0.55) 0%, rgba(136, 0, 21, 0.25) 100%);
                }

                .asc-junction {
                    position: absolute;
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background-color: rgba(136, 0, 21, 0.55);
                    opacity: 0.6;
                    transform: translate(-50%, -50%);
                }

                .asc-traveler {
                    position: absolute;
                    width: 5.5px;
                    height: 5.5px;
                    border-radius: 50%;
                    background-color: rgba(180, 0, 25, 0.72);
                    box-shadow: 0 0 7px 1.8px rgba(180, 0, 25, 0.5), 0 0 12px 3px rgba(180, 0, 25, 0.25);
                    transform: translate(-50%, -50%);
                }

                /* Panel mode traveler animations */
                .asc-panel .asc-traveler.pt-0 { animation: panelTraveler0 38s infinite linear !important; }
                .asc-panel .asc-traveler.pt-1 { animation: panelTraveler1 44s infinite linear !important; }
                .asc-panel .asc-traveler.pt-2 { animation: panelTraveler2 34s infinite linear !important; }
                .asc-panel .asc-traveler.pt-3 { animation: panelTraveler3 48s infinite linear !important; }
                .asc-panel .asc-traveler.pt-4 { animation: panelTraveler4 40s infinite linear !important; }
                .asc-panel .asc-traveler.pt-5 { animation: panelTraveler5 44s infinite linear !important; }
                .asc-panel .asc-traveler.pt-6 { animation: panelTraveler6 50s infinite linear !important; }
                .asc-panel .asc-traveler.pt-7 { animation: panelTraveler7 38s infinite linear !important; }
                .asc-panel .asc-traveler.pt-8 { animation: panelTraveler8 42s infinite linear !important; }
                .asc-panel .asc-traveler.pt-9 { animation: panelTraveler9 46s infinite linear !important; }

                @keyframes panelTraveler0 {
                    0%, 100% { left: 212.5px; top: 0px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                    50% { left: 212.5px; top: 528px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                }
                @keyframes panelTraveler1 {
                    0%, 100% { left: 118.75px; top: 528px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                    50% { left: 118.75px; top: 0px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                }
                @keyframes panelTraveler2 {
                    0%, 100% { left: 343.75px; top: 101.5px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                    50% { left: 343.75px; top: 528px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                }
                @keyframes panelTraveler3 {
                    0%, 100% { left: 0px; top: 57.1px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                    50% { left: 262.5px; top: 57.1px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                    75% { left: 262.5px; top: 444px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                }
                @keyframes panelTraveler4 {
                    0%, 100% { left: 162.5px; top: 38px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                    50% { left: 162.5px; top: 431.5px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                }
                @keyframes panelTraveler5 {
                    0%, 100% { left: 29.69px; top: 0px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                    50% { left: 29.69px; top: 528px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                }
                @keyframes panelTraveler6 {
                    0%, 100% { left: 71.88px; top: 528px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                    50% { left: 71.88px; top: 126.9px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                }
                @keyframes panelTraveler7 {
                    0%, 100% { left: 296.88px; top: 0px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                    50% { left: 296.88px; top: 343px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                }
                @keyframes panelTraveler8 {
                    0%, 100% { left: 0px; top: 253.8px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                    50% { left: 400px; top: 253.8px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                }
                @keyframes panelTraveler9 {
                    0%, 100% { left: 381.25px; top: 528px; transform: translate(-50%, -50%) scale(1.15); opacity: 0.7; }
                    50% { left: 381.25px; top: 0px; transform: translate(-50%, -50%) scale(0.85); opacity: 0.25; }
                }

                /* Full mode traveler animations */
                .asc-full .asc-traveler.t-0 { animation: fullTraveler0 38s infinite linear; }
                .asc-full .asc-traveler.t-1 { animation: fullTraveler1 44s infinite linear; }
                .asc-full .asc-traveler.t-2 { animation: fullTraveler2 34s infinite linear; }
                .asc-full .asc-traveler.t-3 { animation: fullTraveler3 48s infinite linear; }
                .asc-full .asc-traveler.t-4 { animation: fullTraveler4 40s infinite linear; }
                .asc-full .asc-traveler.t-5 { animation: fullTraveler5 44s infinite linear; }
                .asc-full .asc-traveler.t-6 { animation: fullTraveler6 50s infinite linear; }
                .asc-full .asc-traveler.t-7 { animation: fullTraveler7 38s infinite linear; }
                .asc-full .asc-traveler.t-8 { animation: fullTraveler8 42s infinite linear; }
                .asc-full .asc-traveler.t-9 { animation: fullTraveler9 46s infinite linear; }
                .asc-full .asc-traveler.t-10 { animation: fullTraveler10 52s infinite linear; }

                @keyframes fullTraveler0 {
                    0%, 100% { left: 53.0%; top: 0%; opacity: 0.2; }
                    50% { left: 53.0%; top: 100%; opacity: 0.7; }
                }
                @keyframes fullTraveler1 {
                    0%, 100% { left: 29.5%; top: 100%; opacity: 0.7; }
                    50% { left: 29.5%; top: 0%; opacity: 0.2; }
                }
                @keyframes fullTraveler2 {
                    0%, 100% { left: 85.8%; top: 19.2%; opacity: 0.2; }
                    50% { left: 85.8%; top: 100%; opacity: 0.7; }
                }
                @keyframes fullTraveler3 {
                    0%, 100% { left: 65.5%; top: 96%; opacity: 0.7; }
                    50% { left: 65.5%; top: 12%; opacity: 0.2; }
                }
                @keyframes fullTraveler4 {
                    0%, 100% { left: 40.5%; top: 7.2%; opacity: 0.2; }
                    50% { left: 40.5%; top: 81.7%; opacity: 0.7; }
                }
                @keyframes fullTraveler5 {
                    0%, 100% { left: 7.3%; top: 67.3%; opacity: 0.7; }
                    50% { left: 7.3%; top: 0%; opacity: 0.2; }
                }
                @keyframes fullTraveler6 {
                    0%, 100% { left: 14.1%; top: 63.7%; opacity: 0.2; }
                    50% { left: 100%; top: 63.7%; opacity: 0.7; }
                }
                @keyframes fullTraveler7 {
                    0%, 100% { left: 100%; top: 81.7%; opacity: 0.7; }
                    50% { left: 0%; top: 81.7%; opacity: 0.2; }
                }
                @keyframes fullTraveler8 {
                    0%, 100% { left: 41.4%; top: 48.1%; opacity: 0.2; }
                    50% { left: 100%; top: 48.1%; opacity: 0.7; }
                }
                @keyframes fullTraveler9 {
                    0%, 100% { left: 95.3%; top: 100%; opacity: 0.7; }
                    50% { left: 95.3%; top: 0%; opacity: 0.2; }
                }
                @keyframes fullMoveVert {
                    0% { top: 0%; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                    50% { top: 100%; opacity: 0.7; transform: translate(-50%, -50%) scale(1.15); }
                    100% { top: 0%; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                }
                @keyframes fullMoveHoriz {
                    0% { left: 0%; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                    50% { left: 100%; opacity: 0.7; transform: translate(-50%, -50%) scale(1.15); }
                    100% { left: 0%; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                }
                @keyframes panelMoveVert {
                    0% { top: 0px; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                    50% { top: 528px; opacity: 0.7; transform: translate(-50%, -50%) scale(1.15); }
                    100% { top: 0px; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                }
                @keyframes panelMoveHoriz {
                    0% { left: 0px; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                    50% { left: 400px; opacity: 0.7; transform: translate(-50%, -50%) scale(1.15); }
                    100% { left: 0px; opacity: 0.18; transform: translate(-50%, -50%) scale(0.85); }
                }
            `}</style>

            {/* Vertical Lines */}
            {verticalLines.map((line, i) => (
                <div 
                    key={`v-${i}`} 
                    className={`asc-transit-line-v ${line.className}`} 
                    style={line.style} 
                />
            ))}

            {/* Horizontal Lines */}
            {horizontalLines.map((line, i) => (
                <div 
                    key={`h-${i}`} 
                    className={`asc-transit-line-h ${line.className}`} 
                    style={line.style} 
                />
            ))}

            {/* Moving Transit Dots (formerly static junctions) */}
            {junctions.map((j, i) => {
                const isVertical = i % 2 === 0
                const duration = 24 + (i % 8) * 4.5
                const delay = -((i * 4.2) % 30)
                const animName = isFull
                    ? (isVertical ? 'fullMoveVert' : 'fullMoveHoriz')
                    : (isVertical ? 'panelMoveVert' : 'panelMoveHoriz')

                const posX = typeof (j as any).x === 'number' ? `${(j as any).x}px` : (j as any).x
                const posY = typeof (j as any).y === 'number' ? `${(j as any).y}px` : (j as any).y

                return (
                    <div 
                        key={`j-moving-${i}`} 
                        className="asc-traveler" 
                        style={{ 
                            left: isVertical ? posX : undefined,
                            top: !isVertical ? posY : undefined,
                            animation: `${animName} ${duration}s infinite ease-in-out ${delay}s`
                        }} 
                    />
                )
            })}

            {/* Travelers (Pulsing Moving Particles) */}
            {travelers.map((t, i) => (
                <div 
                    key={`t-${i}`} 
                    className={`asc-traveler ${t.cls || `t-${10 - i}`}`} 
                    style={{ left: (t as any).x, top: (t as any).y, animationDelay: t.d }} 
                />
            ))}
        </div>
    )
}

export default NewTransitLines
